// extracted by mini-css-extract-plugin
export default {"title-container":"PoliticaPrivacidade_title-container__huEMW","policy-container":"PoliticaPrivacidade_policy-container__HEXP4"};